module.exports = __webpack_public_path__ + "static/media/solids.ebe48231.png";